var map = {
	"./amex.png": "7543",
	"./default_card.png": "07c7",
	"./diners.png": "22b2",
	"./discover.png": "3f91",
	"./jcb.png": "00d2",
	"./mastercard.png": "aea1",
	"./visa.png": "bce3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6501";